import { useSearchParams } from "react-router-dom";
import { DelaysParetoPage } from "./DelaysParetoPage";

const DelaysPareto = () => {
  const [searchParams] = useSearchParams();
  const assetId = Number(searchParams.get("assetId"));

  return <DelaysParetoPage key={`${assetId}`} assetId={assetId} />;
};
export default DelaysPareto;
